/** @format */
import React, { useEffect, useRef, forwardRef, useImperativeHandle, useState } from 'react'
import echarts, { colorOptions } from 'src/utils/echarts'
import { useDeepCompareEffect } from 'react-use'

export const defaultOptions = {
  title: {},
  tooltip: {
    show: true,
    trigger: 'axis',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
  legend: { show: true, type: 'scroll' },
  grid: {
    left: '20px',
    right: '35px',
    top: '30px',
    bottom: '5px',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    // 默认十字线配置
    axisPointer: {
      show: false
    }
  },
  yAxis: {
    show: true,
    // 默认十字线配置
    axisPointer: {
      show: false
    }
  }
}

export interface BaseChartMethod {
  chartResize?: (opt?: any) => void
  selectchanged?: (dataIndex: number[], seriesIndex: number) => void
  getOptions?: () => any
  dispatchAction?: (opt: any) => void
}

interface BaseChartProps {
  options?: any
  initHeight?: number
  ref?: any
  widt?: number
  onLegendChange?: (params: any) => void
  getChartOption?: (opt: any) => void // 图表渲染完成时返回option
}

const BaseChart: React.FC<BaseChartProps> = forwardRef(
  ({ options, initHeight, widt, onLegendChange, getChartOption }, ref) => {
    const chartInstance = useRef(null)
    const container = useRef(null)
    const [isFin, setFin] = useState<boolean>(false)

    useEffect(() => {
      widt && chartInstance?.current?.resize && chartInstance?.current?.resize()
    }, [widt])

    useEffect(() => {
      if (!container) return
      if (!chartInstance || chartInstance.current === null) {
        chartInstance.current = echarts.init(container.current)
      }
      return () => {
        chartInstance.current.dispose()
      }
    }, [container])

    useDeepCompareEffect(() => {
      if (!options) return
      if (chartInstance.current) {
        const setOptions = {
          ...defaultOptions,
          ...colorOptions,
          ...options
        }
        if (chartInstance?.current && !isFin && onLegendChange) {
          chartInstance.current.on('legendselectchanged', (params: any) => {
            onLegendChange(params)
            setFin(true)
          })
        }

        chartInstance.current.setOption(setOptions)
        chartInstance.current.resize()
      }
      return () => {
        chartInstance.current.clear()
      }
    }, [options, chartInstance, isFin])

    // useEffect(() => {
    //   if (chartInstance?.current && !isFin && getChartOption) {
    //     chartInstance.current.on('finished', () => {
    //       if (chartInstance?.current?.getOption) {
    //         getChartOption(chartInstance?.current?.getOption())
    //         setFin(true)
    //       }
    //     })
    //   }
    // }, [chartInstance, isFin, getChartOption])

    useImperativeHandle(ref, () => ({
      chartResize: opt => chartInstance?.current?.resize(opt),
      getOptions: () => chartInstance.current?.getOption(),
      dispatchAction: opt => chartInstance?.current?.dispatchAction(opt)
    }))
    return <div ref={container} style={{ width: '100%', height: '100%' }}></div>
  }
)

export default BaseChart
